const SCOPED_STYLES_PREFIX = 'SCOPED_STYLES-';

// @todo TM-261 - what problem this mixin solve? f2f
export default {
  data() {
    return {
      styles: '',
      styleClass: '',
    };
  },
  beforeMount() {
    // @todo TM-261 you can get nice big random string with App.es6.shared.random() with bigger entropy
    this.styleClass = `${SCOPED_STYLES_PREFIX}-${Math.floor(Math.random() * 100000)}`;
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(this.styles));
    style.classList.add(this.styleClass);
    document.head.appendChild(style);
  },
  beforeUnmount() {
    const style = document.querySelector(`.${this.styleClass}`);
    document.head.removeChild(style);
  },
};
